import { Form, Formik } from "formik";
import React from "react";
import { Button, Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import FormikDropdown from "../../components/Forms/FormikDropdown";
import FormikTextField from "../../components/Forms/FormikTextField";
import LoaderButton from "../../components/LoaderButton";
import { Constants } from "../../libs/Constants";
import { create } from "../../libs/dbFunctions";
import { round } from "../../libs/utils";

const PayLoanButton = ({
  onPay,
  userObj,
  closingPeriodDetails,
  loanAmount,
  refresh,
}) => {
  const [openModal, setOpenModal] = React.useState(false);
  if (!userObj) {
    return <></>;
  }
  const handleSubmit = async (values) => {
    setOpenModal(false);
    if (onPay) {
      onPay();
    }
    // Call API to do the transaction
    try {
      await create(Constants.dbTypes.TRANSACTION, {
        amount: values.amount,
        account: values.account,
        userId: userObj.id,
        periodStartdate: closingPeriodDetails.periodStartdate,
        periodEnddate: closingPeriodDetails.periodEnddate,
        companyId: userObj.companyId,
        paymentMode: 'dwolla',
        send: false,
      });
      toast.success(
        "Transfer initiated successfully. It might take 1-2 days to settle the transfer"
      );
      refresh();
    } catch (err) {
      toast.error("Unable to complete the transfer. Contact administrator");
    }
  };
  return (
    <>
      {" "}
      <Button
        onClick={() => {
          setOpenModal(true);
        }}
        variant="primary"
      >
        Pay now
      </Button>
      <Modal
        show={openModal}
        onHide={() => setOpenModal(false)}
        size="md"
        backdrop="static"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="contribution-modal font-secondary"
      >
        <Modal.Header className="p-4" closeButton>
          <Modal.Title>Repayment of Loan</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            onSubmit={handleSubmit}
            initialValues={{
              amount: round(loanAmount).toFixed(2),
              account: "",
            }}
            validateOnMount
          >
            {({ isValid, isSubmitting }) => (
              <Form className="w-100">
                <FormikTextField
                  size="lg"
                  controlId="amount"
                  label="Amount"
                  disabled={true}
                  type="number"
                  name="amount"
                  className="mb-4"
                />

                <FormikDropdown
                  name="account"
                  label="Select Account"
                  options={userObj.accounts.map((acc) => {
                    return {
                      value: acc.id,
                      name: `${acc.name} - ${acc.bankName}`,
                    };
                  })}
                  placeholder="Select Account"
                ></FormikDropdown>
                <LoaderButton
                  block
                  type="submit"
                  variant="primary"
                  size="lg"
                  text="Next"
                  className="mb-2"
                  isLoading={isSubmitting}
                  disabled={!isValid || isSubmitting}
                >
                  Pay now
                </LoaderButton>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default PayLoanButton;
